import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/mousewheel';
import { useAppContext } from 'providers/AppProvider';
import { Brand } from 'api/categories/_requests';
import { Link } from 'react-router-dom';

interface BrandScrollableCardProps {
  brands: Brand[];
}

const BrandScrollableCard = ({ brands }: BrandScrollableCardProps) => {
  const {
    config: { theme }
  } = useAppContext();

  return (
    <div className="mb-4 px-2">
      <Swiper
        modules={[Mousewheel]}
        slidesPerView="auto"
        spaceBetween={24}
        mousewheel
        freeMode
        grabCursor
        breakpoints={{
          0: {
            spaceBetween: 16
          },
          576: {
            spaceBetween: 20
          },
          992: {
            spaceBetween: 24
          }
        }}
        style={{ paddingBottom: '4px' }}
      >
        {brands?.map((brand, index) => (
          <SwiperSlide key={index} style={{ width: '96px', flexShrink: 0 }}>
            <div
              className={`border border-translucent rounded-circle shadow-sm p-2 transition-all duration-300 hover:shadow-lg ${
                theme === 'dark' ? 'bg-dark' : 'bg-white'
              }`}
              style={{
                width: '96px',
                height: '96px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto',
                cursor: 'pointer'
              }}
            >
              <Link to={`/branddetails/${brand.slug}`}>
                <img
                  src={brand.image}
                  alt={`Brand ${index}`}
                  className="img-fluid"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                    aspectRatio: '1 / 1',
                    borderRadius: '50%'
                  }}
                />
              </Link>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default BrandScrollableCard;
